function Tag({ tag }) {
  return (
    <div>
      <p className="tag">{tag}</p>
    </div>
  )
}

export default Tag
